import actions from "./actions";

const initState = {
  rechargePriceMappingData: [],
  loading: false,
  rechargePriceMappingSuccess: null,
  rechargePriceMappingError: null,
  // Add and Update
  addRechargePriceMappingData: [],
  buttonLoading: false,
  addRechargePriceMappingSuccess: null,
  addRechargePriceMappingError: null,

  rechargePlanWiseMappingLoading: false,
  rechargePlanWiseMappingError: null,
  rechargePlanWiseMappingMessage: null,
  rechargePlanWiseMappingList: [],

  openRechargePortinModal: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA:
      return {
        ...state,
        loading: true,
        rechargePriceMappingError: null,
        rechargePriceMappingSuccess: null,
      };

    case actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        rechargePriceMappingError: null,
        rechargePriceMappingSuccess: null,
        rechargePriceMappingData: action.payload.data,
      };

    case actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA_FAILED:
      return {
        ...state,
        loading: false,
        rechargePriceMappingError: action.payload.error,
        rechargePriceMappingSuccess: null,
      };

    case actions.GET_RECHARGE_PLAN_WISE_MAPPING:
      return {
        ...state,
        rechargePlanWiseMappingLoading: true,
        rechargePlanWiseMappingError: null,
        rechargePlanWiseMappingMessage: null,
      };

    case actions.GET_RECHARGE_PLAN_WISE_MAPPING_SUCCESS:
      return {
        ...state,
        rechargePlanWiseMappingLoading: false,
        rechargePlanWiseMappingError: null,
        rechargePlanWiseMappingMessage: null,
        rechargePlanWiseMappingList: action.payload.data,
      };

    case actions.GET_RECHARGE_PLAN_WISE_MAPPING_FAILED:
      return {
        ...state,
        rechargePlanWiseMappingLoading: false,
        rechargePlanWiseMappingError: action.payload.error,
        rechargePlanWiseMappingMessage: null,
      };
    case actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA:
      return {
        ...state,
        loading: true,
        buttonLoading: true,
        addRechargePriceMappingError: null,
        addRechargePriceMappingSuccess: null,
      };

    case actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addRechargePriceMappingError: null,
        addRechargePriceMappingSuccess: action.message,
        rechargePriceMappingData: action.data,
      };

    case actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA_FAILED:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addRechargePriceMappingError: action.error,
        addRechargePriceMappingSuccess: null,
      };

    case actions.OPEN_UPDATE_RECHARGE_PORTIN_MODAL:
      return {
        ...state,
        openRechargePortinModal: true,
      };

    case actions.CLOSE_UPDATE_RECHARGE_PORTIN_MODAL:
      return {
        ...state,
        openRechargePortinModal: false,
      };
    case actions.RESET_RECHARGE_PRICE_MAPPING_MESSAGES:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        rechargePriceMappingSuccess: null,
        rechargePriceMappingError: null,
        addRechargePriceMappingSuccess: null,
        addRechargePriceMappingError: null,
      };
    default:
      return state;
  }
}
